import request from '../../request';

var nAgt = navigator.userAgent;
var browserName = navigator.appName;
var fullVersion = '' + parseFloat(navigator.appVersion);
var majorVersion = parseInt(navigator.appVersion, 10);
var nameOffset, verOffset, ix;

// eslint-disable-next-line
if ((verOffset = nAgt.indexOf('Opera')) !== -1) {
  browserName = 'Opera';
  fullVersion = nAgt.substring(verOffset + 6);
  // eslint-disable-next-line
  if ((verOffset = nAgt.indexOf('Version')) !== -1)
    fullVersion = nAgt.substring(verOffset + 8);
  // eslint-disable-next-line
} else if ((verOffset = nAgt.indexOf('MSIE')) !== -1) {
  // In MSIE, the true version is after "MSIE" in userAgent
  browserName = 'Microsoft Internet Explorer';
  fullVersion = nAgt.substring(verOffset + 5);
  // eslint-disable-next-line
} else if ((verOffset = nAgt.indexOf('Chrome')) !== -1) {
  // In Chrome, the true version is after "Chrome"
  browserName = 'Chrome';
  fullVersion = nAgt.substring(verOffset + 7);
  // eslint-disable-next-line
} else if ((verOffset = nAgt.indexOf('Safari')) !== -1) {
  // In Safari, the true version is after "Safari" or after "Version"
  browserName = 'Safari';
  fullVersion = nAgt.substring(verOffset + 7);
  // eslint-disable-next-line
  if ((verOffset = nAgt.indexOf('Version')) !== -1)
    fullVersion = nAgt.substring(verOffset + 8);
  // eslint-disable-next-line
} else if ((verOffset = nAgt.indexOf('Firefox')) !== -1) {
  // In Firefox, the true version is after "Firefox"
  browserName = 'Firefox';
  fullVersion = nAgt.substring(verOffset + 8);
  // eslint-disable-next-line
} else if (
  (nameOffset = nAgt.lastIndexOf(' ') + 1) < (verOffset = nAgt.lastIndexOf('/'))
) {
  // In most other browsers, "name/version" is at the end of userAgent
  browserName = nAgt.substring(nameOffset, verOffset);
  fullVersion = nAgt.substring(verOffset + 1);
  // eslint-disable-next-line
  if (browserName.toLowerCase() == browserName.toUpperCase()) {
    browserName = navigator.appName;
  }
}
// eslint-disable-next-line
if ((ix = fullVersion.indexOf(';')) !== -1)
  fullVersion = fullVersion.substring(0, ix);
// eslint-disable-next-line
if ((ix = fullVersion.indexOf(' ')) !== -1)
  fullVersion = fullVersion.substring(0, ix);

majorVersion = parseInt('' + fullVersion, 10);
if (isNaN(majorVersion)) {
  fullVersion = '' + parseFloat(navigator.appVersion);
  majorVersion = parseInt(navigator.appVersion, 10);
}
let old = false;
if (browserName === 'Chrome' && majorVersion < 20) old = true;
else if (browserName === 'Safari' && majorVersion < 6) old = true;
else if (browserName === 'Firefox' && majorVersion < 20) old = true;
else if (
  navigator.appName === 'Microsoft Internet Explorer' ||
  !!(navigator.userAgent.match(/Trident/) || navigator.userAgent.match(/rv:11/))
)
  old = true;

if (!window.ActiveXObject && 'ActiveXObject' in window) old = false;

if (old)
  request({
    url: 'old-browser',
    body: { browserName, majorVersion },
  });
export default old;



// WEBPACK FOOTER //
// ./src/views/auth/browser.js